module.exports = __webpack_public_path__ + "img/logo2.86746f17.png";